async function geoCode(address, ymaps) {
  const res = await ymaps.geocode(address);
  const geoObject = res.geoObjects.get(0);
  return geoObject ? geoObject.geometry.getCoordinates() : null;
}

export async function initContactMap(element, ymaps) {
  if (!element) {
    return;
  }
  const { city, address } = element.dataset;
  const coords = await geoCode(`${city}, ${address}`, ymaps);
  if (!coords) {
    return;
  }
  const map = new ymaps.Map(element, {
    center: coords,
    zoom: 17,
    controls: ['zoomControl'],
  });

  map.controls.get('zoomControl').options.set({ position: { top: 48, left: 10 } });

  map.behaviors.disable('scrollZoom');

  const placeMark = new ymaps.Placemark(coords);
  map.geoObjects.add(placeMark);
}
const mapElement = document.querySelector('.js-contact-map');
if (mapElement && window.ymaps) {
  const { ymaps } = window;
  window.ymaps.ready(() => initContactMap(mapElement, ymaps));
}
